<template lang="pug">
  main
    NavBarAccesosIRGE
    ModalYesNo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:saveData="eliminarAcceso")
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .container
        h3.title Autotanques Recibidos
        .columns.is-mobile
          .column.is-2-desktop.is-3-tablet.has-text-centered
            label.label Fecha de Entradas:
            .field
              .control
                flat-pickr(
                  v-model='date'
                  :config="config"
                  class="input"
                )
          .column.is-offset-6-desktop.is-4-desktop.is-offset-4-tablet.is-3-tablet.has-text-centered
            .field
              label.label Filtrar (Autotanque)
                .control
                  input.input.is-primary(
                    type='text', 
                    v-model="filtro"
                  )
        .columns.is-mobile.is-vcentered
          .column.is-offset-one-fifths-desktop.is-three-fifth-desktop.is-offset-one-quarter-tablet.is-half-tablet.has-text-centered
            .notification.is-primary(v-show="!tieneDatos")
              button.delete
              |   Aún no existen entradas de Autotanques en el día de hoy.
        .columns(v-show="tieneDatos")
          .column.is-12-tablet.is-full-mobile.dataTb
            table#tbRevisiones.table.is-striped.is-responsive
              thead
                tr
                  th
                    abbr(title='Número') #
                  th Autotanques
                  th
                    abbr(title='Fecha y Hora') LLegada
                  th
                    abbr(title='Fecha y Hora') Acceso
                  th
                    abbr(title='Entrada a carga') Entrada Carga
                  th  
                    abbr(title='Inicio a carga') Inicio Carga
                  th
                    abbr(title='Fin de Carga') Fin de Carga
                  th
                    abbr(title='3218') Documentación
                  th
                    abbr(title='Facturación') Facturación
                  th
                    abbr(title='Salida') Salida
                  th
                    abbr(title='Operador') Operador
                  th
                    abbr(title='Fotografía') Fotografía
              tbody
                tr(v-for="(data, index) in recepciones_filter" :key="data.id")
                  td 
                    a.button.is-dark.is-small.is-rounded(@click="editarAcceso(data)")
                      | {{ index + 1 }}
                    br
                    a.button.is-danger.is-small.is-rounded(@click="askDelete(data)" v-show="userLogin.cargo === '340' || userLogin.categoria ==='0' || userLogin.cargo === '240'")
                      i.fas.fa-trash
                  td(v-html="condicion_Pg(data)" @click="irDetalle(data)")
                  td {{ getHora(data.fechaLlegada) }}
                    a.button.is-warning.is-small.is-rounded(@click="pausarPG(data)" v-show="(data.turno !== '-1' && userLogin.cargo === '340') || (data.turno !== '-1' && userLogin.categoria ==='0') || (data.turno !== '-1' && userLogin.cargo === '240')")
                      i.fas.fa-pause
                    a.button.is-link.is-small.is-rounded(@click="quitarPausaPg(data)" v-show="(data.turno === '-1' && userLogin.cargo === '340') || (data.turno === '-1' && userLogin.categoria ==='0') || (data.turno === '-1' && userLogin.cargo === '240')")
                      i.fas.fa-play
                  td(v-if="parseInt(data.estado) >= 1 ") 
                    a.button.is-light.is-small(@click="ir23Puntos(data, 'e')")
                      | {{ getHora(data.fechaAcceso) }}
                    span.tag.is-dark(v-if="data.firma.length > 0" @click="pdfPuntos(data)")
                        | 23 Puntos &nbsp
                        i.fas.fa-file-pdf
                    span(v-if="data.observaciones.length > 0")
                      small.has-text-danger {{ data.observaciones }}
                  td(v-else) 
                    a.button.is-dark.is-small(@click="ir23Puntos(data, 'n')")
                      | 23 Puntos
                  td(v-if="parseInt(data.estado) >= 2") 
                    | {{ getHora(data.fechaEntrada_carga) }}
                  td(v-else) 
                    |
                  td(v-if="parseInt(data.estado) >= 3") 
                    | {{ getHora(data.fechaInicio_carga) }}
                  td(v-else) 
                    |
                  td(v-if="parseInt(data.estado) >= 4") 
                    | {{ getHora(data.fechaFin_carga) }}
                  td(v-else) 
                    |
                  td(v-if="parseInt(data.estado) >= 5")
                    | {{ getHora(data.fechaPorte) }}
                  td(v-else) 
                    |
                  td(v-if="parseInt(data.estado) >= 6") 
                    | {{ getHora(data.fechaFacturacion) }}
                  td(v-else) 
                    |
                  td(v-if="parseInt(data.estado) >= 7") 
                    | {{ getHora(data.fechaSalida) }}
                  td(v-else) 
                    |
                  td 
                    small {{ data.nombreOperador }}
                    br
                    b.has-size-7 📱{{ data.telefonoOperador}}
                  td
                    figure.image.is-128x128
                      img(:src="getfoto(data.fotoOperador)")
        .columns.column-blanco
</template>

<script>
  import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
  import turnosServicesIRGE from '@/services/irge/turnosIRGE.js'
  import usuariosServices from '@/services/usuarios/usuarios.js'
  import NavBarAccesosIRGE from './layout/NavBarAccesos.vue'
  import Loader from '@/components/shared/Loader.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import ModalYesNo from '@/components/sca_Componentes/acceso/shared/ModalYesNo.vue'

  export default {
    name: 'HomeAccesosIRGE',
    components: { NavBarAccesosIRGE, Loader, flatPickr, ModalYesNo },
    data () {
      return {
        recepciones: [],
        recepciones_filter: [],
        tieneDatos: false,
        isLoading: true,
        limit: 0,
        date: '',
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        modalStatus: false,
        contentModal: '',
        titleModal: '',
        pgSelect: '',
        refresh: null,
        pg_buscarData: [],
        filtro: '',
        position: 'top-right',
        isBasculaUser: false,
        isOperacionesUser: false,
        item_to_delete: {}
      }
    },
    watch: {
      date () {
        this.obtenerAutos()
      },
      filtro () {
        console.log(this.filtro)
        let textoGrupo = ''
        const accesosFilter = this.recepciones.filter( acceso => { 

          switch (acceso.unidadNeg) {
          case 'gN':
            textoGrupo = 'NIETO'
            break
          case 'gSI':
            textoGrupo = 'SONIGAS-I'
            break
          case 'gSM':
            textoGrupo = 'SONIGAS-C'
            break
          case 'gG':
            textoGrupo = 'GLOBAL'
            break
          case 'gMN':
            textoGrupo = 'METRO-NIETO'
            break
          case 'gMab':
            textoGrupo = 'MABARAK'
            break
          case 'gU':
            textoGrupo = 'URIBE'
            break
          case 'gMet':
            textoGrupo = 'METROPOLITANO'
            break
        
          default:
            break
        }
          let texto_filtroMayus = `${acceso.pg} ${acceso.unidadNeg} ${textoGrupo}`.toUpperCase()
          let texto_filtroMinus = `${acceso.pg} ${acceso.unidadNeg} ${textoGrupo}`.toLowerCase()
          let textoCompleto = `${texto_filtroMayus} ${texto_filtroMinus}`
          return textoCompleto.includes(this.filtro)
        }) 
        console.log(accesosFilter)
        this.recepciones_filter = accesosFilter
      }
    },
    methods: {
      obtenerAutos () {
        // let fecha = moment().format('YYYY-MM-DD')
        let fecha = this.date
        autotanquesServicesIRGE.searchRec_All(fecha)
          .then(res => {
            console.log(res)
            if (res.length > 0) {
              this.recepciones = res
              this.recepciones_filter = this.recepciones
              this.tieneDatos = true
            } else {
              this.tieneDatos = false
            }
          })
        setTimeout(() => {
          this.isLoading = false
        }, 1000)
      },

      mostrarEntrada (tanque) {
        this.isLoading = true
        setTimeout(() => {
          this.$store.commit('autotanqueSalida', tanque)
          this.isLoading = false
          this.$router.push({ path: '/IRGE/Accesos/Salida' })
        }, 750)
      },

      isEmplazado: function (emplazado) {
        console.log(emplazado)
        if (emplazado === '0') {
          return false
        } else {
          return true
        }
      },

      isInPlanta (rec) {
        if (rec.estado === '1') {
          return rec.fechaSalida
        } else {
          return 'Aun Sigue en Planta'
        }
      },

      isFinish: function (finalizado) {
        if (finalizado === '7') {
          return false
        } else {
          return true
        }
      },

      getfoto (foto) {
        let currentUrl = window.location.hostname
        return `https://${currentUrl}/SCA_Tuxpan${foto}`
      },

      getHora (fechaHora) {
        let hora = ''
        if (fechaHora === '' || fechaHora ==='0000-00-00 00:00:00') {
          hora= ''
        } else {
          hora = moment(fechaHora).format('HH:mm:ss')
        }
        return hora
      }, 
      
      saveData (result) {
        console.log(result)
        

        if (result) {
          let fh_acceso = moment().format('YYYY-MM-DD HH:mm:ss')
          autotanquesServicesIRGE.updateAcceso(this.pgSelect.id, fh_acceso)
            .then(res => {
              console.log(res)
              if (res.success) {
                let toast = this.$toasted.show(`El acceso del autotanque ${this.pgSelect.pg}, ha sido registrada.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'check',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      
                      toastObject.goAway(0)
                    }
                  },
                })
                this.obtenerAutos()
              } else {
                let toast = this.$toasted.show(`Error, el acceso del autotanque ${this.pgSelect.pg}, no ha sido registrado.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'exclamation-triangle',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
            })

        } else {
          this.titleModal = ''
          this.contentModal = ''
          this.modalStatus = false
          this.idPgSelect = ''
        }
      },

      actualizarDatosCarga () {
        console.log('Actualizar datos de carga')
        this.pg_buscarData = this.recepciones_filter.filter( rec => rec.estado === '1')

        this.pg_buscarData.forEach(element => {
          autotanquesServicesIRGE.getDataCarga_Pg_Salida(element.pg)
            .then (res => {
              if (element.fechaEntrada_carga === '0000-00-00 00:00:00' || element.fechaInicio_carga === '0000-00-00 00:00:00' || element.fechaFin_carga === '0000-00-00 00:00:00') {
                let estadoInt = 5
                if (res[0].estado === '0') {
                  estadoInt = 5
                } else {
                  estadoInt = 6
                }
                autotanquesServicesIRGE.updateDataCargas_recepcion(element.id, res[0].entrada, res[0].inicio, res[0].fin, estadoInt)
                  .then( resp => {
                    console.log(res)
                  })
              }
            })
        })
        this.obtenerAutos()
      },

      ir23Puntos (auto, accion) {
        if (this.isBasculaUser || this.isOperacionesUser) {
          return
        }

        this.$store.commit('tanqueActual', auto)
        if (accion === 'e') {
          this.$store.commit('tanqueIsEditing', true)
        } else {
          this.$store.commit('tanqueIsEditing', false)
        }

        this.$router.push('/IRGE/Accesos/Puntos')
      },

      condicion_Pg (auto) {
        let textoGrupo = ''

        switch (auto.unidadNeg) {
          case 'gN':
            textoGrupo = '<span class="tag is-danger">Nieto</span>'
            break
          case 'gSI':
            textoGrupo = '<span class="tag is-dark">Soni-I</span>'
            break
          case 'gSM':
            textoGrupo = '<span class="tag is-light">Soni-Mx</span>'
            break
          case 'gG':
            textoGrupo = '<span class="tag is-primary">Global</span>'
            break
          case 'gMN':
            textoGrupo = '<span class="tag is-link">Metro-Nieto</span>'
            break
          case 'gMab':
            textoGrupo = '<span class="tag is-info">Mabarak</span>'
            break
          case 'gU':
            textoGrupo = '<span class="tag is-success">Uribe</span>'
            break
          case 'gMet':
            textoGrupo = '<span class="tag is-warning">Metropolitano</span>'
            break
          case 'gUP':
            textoGrupo = '<span class="tag is-link">Uribe-Propangol</span>'
            break
        
          default:
            break
        }

        switch (auto.estado) {
          case '0':
            if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
            <br>
            <small>C. Turno: <b>${auto.claveTurno}</b></small>
            <br/>
            <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '1':
            if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '2':
            if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
            <br>
            <small><b>${auto.claveTurno}</b></small>
            <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '3':
            if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
            <br>
            <small><b>${auto.claveTurno}</b></small>
            <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '5':
            if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
            <br>
            <small><b>${auto.claveTurno}</b></small>
            <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '4':
            if (auto.emplazado === '1') {
              return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-primary is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '5':
            if (auto.emplazado === '1') {
              return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-dark is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '6':
            if (auto.emplazado === '1') {
              return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-dark is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
          case '7':
            if (auto.emplazado === '1') {
              return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            } else {
              return `<a class="button is-black is-rounded">${auto.pg}</a>
              <br>
              <small><b>${auto.claveTurno}</b></small>
              <br/>
              <small><b>${textoGrupo}</small>`
            }
            break
        
          default:
            break
        }

        if (auto.estado === '5') {
          return `<a class="button is-black is-rounded">${auto.pg}</a>`
        } else {
          if (auto.emplazado === '1') {
            return `<a class="button is-danger is-rounded"><i class="fas fa-ban"></i>&nbsp${auto.pg}</a>`
          } else {
            return `<a class="button is-primary is-rounded">${auto.pg}</a>`
          }
        }
      },

      irDetalle (auto) {
        if (this.isBasculaUser || this.isOperacionesUser) {
          return
        }
        this.$store.commit('autotanqueSalida', auto)
        this.$router.push('/IRGE/Accesos/Salida')
      },

      pdfPuntos (data) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)

        let ruta = ''
        

        if (currentUrl === '10.121.40.125') {
          ruta = '/var/www/html/reportesApp/'
        } else {
          ruta = 'c:/xampp/htdocs/reportesApp/'
        }


        // Obtener la ruta de firma de usuario que reviso los puntos
        console.log('Generar Pdf')
        usuariosServices.getUsuario_Ind(data.idUser_acc)
          .then(res => {
            console.log(res)
            if (res.success) {
              let firma = res.avatar
              let link = `https://${currentUrl}/servidores/reportes/puntosI_IRGE.php?id=${data.id}&firma=${firma}&pg=${data.pg}&fecha=${data.fechaReporte}`
              window.open(link, '_blank')
            } else {
              console.log('Error en usuario')
            }
          })
      },

      pausarPG (auto) {
        this.isLoading = true
        console.log(auto)
        // Asignarle un turno 999 directamente. asi podemos aislarlo en la aplicación de turnos
        turnosServicesIRGE.pausarTurno(auto.claveTurno)
          .then( resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`El autotanque ${auto.pg}, ha sido puesto en Pausa.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'check',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      
                      toastObject.goAway(0)
                    }
                  },
              })
              this.obtenerAutos()
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            } else {
            let toast = this.$toasted.show(`Error: ${resp.repsuesta}, no ha sido registrado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            }
          })
          .catch( e => console.log(e))
      },

      quitarPausaPg (auto) {
        this.isLoading = true
        console.log(auto)
        //Regresar a turno 0
        turnosServicesIRGE.quitarPausa(auto.claveTurno)
          .then( resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`Se ha retirado la pausa del autotanque ${auto.pg}.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'check',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      
                      toastObject.goAway(0)
                    }
                  },
              })
              this.obtenerAutos()
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            } else {
            let toast = this.$toasted.show(`Error: ${resp.repsuesta}, no ha sido registrado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            }
          })
          .catch( e => console.log(e))
      },

      eliminarAcceso (result) {
        this.modalStatus = false
        this.titleModal = ''
        this.contentModal = ''
        if (result) {
          autotanquesServicesIRGE.getAutos_claveTurno(this.item_to_delete.claveTurno)
          .then( rIds => {
            console.log(rIds)
            if (rIds.length > 0) {
              let itemsBorrados = 0
              rIds.forEach(idA => {
                console.log(idA)
                autotanquesServicesIRGE.deletePg_Puntos(idA.id)
                  .then( rDpuntos => {
                    console.log(rDpuntos)
                    if (rDpuntos.success) {
                      itemsBorrados = itemsBorrados + 1
                    } else {
                      console.log(rDpuntos.respuesta)
                    }
                  })
                  .catch( e => console.log(e))
              })
                console.log(itemsBorrados)
                setTimeout(() => {
                  this.borrarAcceso(this.item_to_delete.claveTurno)
                }, 350)
              //
            } else {
              let toast = this.$toasted.show(`Error: No se encontraron registrso relacionados.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            }
          })
          .catch( e => console.log(e))
        }
      },

      askDelete (auto) {
        this.item_to_delete = auto
        this.titleModal = 'Eliminar Acceso ❌'
        this.contentModal = `¿ Desea eliminar el autotanque ${auto.pg}?`
        this.modalStatus = true
      },

      borrarAcceso (cT) {
        console.log(cT)
        autotanquesServicesIRGE.deleteAcceso(cT)
          .then( rdel => {
            console.log(rdel)
            if (rdel.success) {
              // Eliminar en tb turnos
              turnosServicesIRGE.eliminar_ClaveTurno(cT)
                .then( rDTurnos => {
                  console.log(rDTurnos)
                  if (rDTurnos.success) {
                    let toast = this.$toasted.show(`Se ha eliminado el Acceso: ${rDTurnos.respuesta}`, { 
                      theme: "toasted-primary", 
                      position: "bottom-right", 
                      duration : 3000,
                      iconPack: 'fontawesome',
                      icon: 'exclamation-triangle',
                      action : {
                        text : 'Ok',
                        onClick : (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                    })
                    this.obtenerAutos()
                    setTimeout(() => {
                      this.isLoading = false
                    }, 350)
                  } else {
                    let toast = this.$toasted.show(`Error: ${rDTurnos.respuesta}`, { 
                      theme: "toasted-primary", 
                      position: "bottom-right", 
                      duration : 3000,
                      iconPack: 'fontawesome',
                      icon: 'exclamation-triangle',
                      action : {
                        text : 'Ok',
                        onClick : (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                    })
                    setTimeout(() => {
                      this.isLoading = false
                    }, 350)
                  }
                })
                .catch(e => console.log(e))

            } else {
              let toast = this.$toasted.show(`Error: ${rdel.repsuesta}.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              setTimeout(() => {
                this.isLoading = false
              }, 350)
            }
          })
          .catch( e => console.log(e))
      },

      editarAcceso (data) {
        console.log(data)
        this.$router.push(`/IRGE/Accesos/Llegadas/Editar/${data.id}`)
      }
    },
    created () {
      let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
      let hoy = moment()
      let ahoraFinal = moment('05:00am', 'h:mma')
      if (ahoraFinal.isBefore(ahora)) {
        this.date = hoy.format('YYYY-MM-DD')
      } else {
        this.date = hoy.subtract(1, 'days').format('YYYY-MM-DD')
      }
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {
        console.log('created')
        this.obtenerAutos()
      }
    },
    mounted () {
      if (this.userLogin.cargo === '342') {
        this.isBasculaUser = true
      }

      if (this.userLogin.departamento === 4) {
        this.isOperacionesUser = true
      }
    },
    destroyed() {
      clearInterval(this.refresh)
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 120px;
  }

  @media only screen 
  and (min-device-width : 768px) 
  and (max-device-width : 1024px) 
  { 
    .container {
      margin: 10px;
    }

    .is-responsive {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      display: block;
      position: relative;
    }
    td:empty:before {
      content: '\00a0';
    }

    th, td {
      margin: 0;
      vertical-align: top
    }

    th {
      text-align: left;
    }

    thead {
      border-right: solid 2px gray;
      display: block;
      float: left;
    }
    tr {
      display: block;
      padding: 0 10px 0 0;
    }

    th::before {
      content: "\00a0";
    }

    td, th {
      border-width: 0 0 1px;
    }

    tbody {
      display: block;
      width: auto;
      position: relative;
      overflow-x: auto;
      white-space: nowrap;
    }

    tr {
      display: inline-block;
      vertical-align: top;
    }

    th {
      display: block;
      text-align: right;
    }

    td {
      display: block;
      min-height: 1.25em;
      text-align: left;
    }
  }


  @media screen and (max-width: 800px)
  {
    .container {
      margin: 10px;
    }

    .is-responsive {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      display: block;
      position: relative;
    }
    td:empty:before {
      content: '\00a0';
    }

    th, td {
      margin: 0;
      vertical-align: top
    }

    th {
      text-align: left;
    }

    thead {
      border-right: solid 2px gray;
      display: block;
      float: left;
    }
    tr {
      display: block;
      padding: 0 10px 0 0;
    }

    th::before {
      content: "\00a0";
    }

    td, th {
      border-width: 0 0 1px;
    }

    tbody {
      display: block;
      width: auto;
      position: relative;
      overflow-x: auto;
      white-space: nowrap;
    }

    tr {
      display: inline-block;
      vertical-align: top;
    }

    th {
      display: block;
      text-align: right;
    }

    td {
      display: block;
      min-height: 1.25em;
      text-align: left;
    }

  }

  /* @media (min-width:320px) and (orientation: portrait) {
    .botonesPrevNext, .dataTb {
      width: 50vh;
    }
  } */

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/HomeAccesos.vue